module.exports = __webpack_public_path__ + "img/basket.cccbf9d4.png";